import { apiFetch } from '../../../lib/apiClient';
import type {
  JobLogsResponse,
  JobRunDetail,
  JobRunsListResponse,
  JobRunStatus,
  JobRunSummary,
} from '../types/jobs';

const BASE = '/api/project';

export const jobsApi = {
  listJobRuns(
    projectUuid: string,
    page: number,
    pageSize: number,
    status?: JobRunStatus
  ): Promise<JobRunsListResponse> {
    const qs = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
    if (status) qs.set('status', status);
    return apiFetch(`${BASE}/${projectUuid}/jobs?${qs.toString()}`);
  },

  getJobRunDetail(projectUuid: string, runUuid: string): Promise<JobRunDetail> {
    return apiFetch(`${BASE}/${projectUuid}/jobs/${runUuid}`);
  },

  getJobLogs(
    projectUuid: string,
    runUuid: string,
    cursor?: number,
    pageSize = 100
  ): Promise<JobLogsResponse> {
    const qs = new URLSearchParams({ pageSize: String(pageSize) });
    if (cursor !== undefined) qs.set('cursor', String(cursor));
    return apiFetch(`${BASE}/${projectUuid}/jobs/${runUuid}/logs?${qs.toString()}`);
  },

  /** Build a GCP Cloud Logging console URL from an externalLogRef */
  gcpLogUrl(externalLogRef: string | null): string | null {
    if (!externalLogRef) return null;
    // externalLogRef format: "projects/{project}/executions/{execId}"
    const encoded = encodeURIComponent(`resource.type="cloud_run_job" logName="${externalLogRef}"`);
    return `https://console.cloud.google.com/logs/query;query=${encoded}`;
  },

  /** Build JobRunSummary row display label */
  jobLabel(job: Pick<JobRunSummary, 'jobName' | 'relatedResourceName'>): string {
    return job.relatedResourceName ? `${job.jobName} - ${job.relatedResourceName}` : job.jobName;
  },
};
